/**
 * Which website activity event types each surface counts.
 *
 * `WebsiteActivity` also stores `page_view` and custom events. The contact
 * Website Activity surfaces never show those, so anything that counts rows
 * has to say which types it means or it reports a number nobody can
 * reconcile with what is on screen.
 */

/**
 * The event types the Website Activity table lists by default.
 *
 * Saves belong in the log: the agent wants to see that the contact saved a
 * listing, alongside the views and searches around it.
 */
export const WEB_ACTIVITY_TABLE_EVENT_TYPES = [
  'property_view',
  'search',
  'lead_capture',
  'property_saved',
] as const;

/**
 * The event types counted by the "Times visited" counter.
 *
 * Keep this identical to the default Website Activity table so the counter
 * can always be reconciled with the rows shown below it.
 */
export const VISIT_EVENT_TYPES = WEB_ACTIVITY_TABLE_EVENT_TYPES;
